import {
    HttpErrorResponse,
    HttpEvent,
    HttpEventType,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { disable_content_loader } from '@rpt-ngrx/actions/ui.action';

import { HttpCancelService } from '../http-client';

@Injectable()
export class HttpCancelInterceptor implements HttpInterceptor {
    constructor(
        private httpCancelService: HttpCancelService,
        private store: Store,
    ) {}

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        let lastResponse: HttpEvent<any>;
        let error: HttpErrorResponse;

        if (req.url.indexOf(environment.portalBackendURI) !== -1) {
            return next.handle(req);
        }
        if (req.url.indexOf('sites') !== -1 || req.url.match(/reports$/)) {
            return next.handle(req);
        }
        if (req.url.indexOf('by-company') !== -1 || req.url.indexOf('translation') !== -1) {
            return next.handle(req);
        }
        return next.handle(req).pipe(
            takeUntil(this.httpCancelService.onCancelPendingRequests()),
            tap((response: HttpEvent<any>) => {
                lastResponse = response;
            }),
            catchError((err: any) => {
                error = err;
                return throwError(err);
            }),
            finalize(() => {
                if (lastResponse.type === HttpEventType.Sent && !error) {
                    this.store.dispatch(disable_content_loader());
                }
            }),
        );
    }
}
